(function userAddCertificateControllerDefinition() {
    'use strict';

    angular.module('User')
        .controller('UserAddCertificateController', [
            '$scope', 'config', '$state', '$stateParams', '$translate', 'errorsExtend', 'adminUserService', 'certificateUserService', 'authExtend',
            function userAddCertificateController($scope, config, $state, $stateParams, $translate, errors, adminUserService, certificateUserService, authExtend) {

                var fileUploadInfo = null;

                var resetFileUpload = function resetFileUploadFn() {
                    fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };


                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('pkcs') > -1) {

                        if (fileUploadInfo.promise !== null) {
                            fileUploadInfo.promise.abort();
                            fileUploadInfo.promise = null;
                        }
                        fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        fileUploadInfo.selectedFile = files[0];

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.removeCertificate = function () {
                    resetFileUpload();
                };

                $scope.cancel = function () {
                    $state.go("inicio");
                };

                $scope.save = function () {
                    if (!fileUploadInfo.selectedFile || !$scope.certificate.expirationDate) {
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (fileUploadInfo.promise !== null) {
                        fileUploadInfo.promise.abort();
                        fileUploadInfo.promise = null;
                    }

                    return certificateUserService.upload($scope.certificate, fileUploadInfo.selectedFile)
                        .then(function () {
                                $state.go("inicio");
                        },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.load = function () {
                    $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);
                    resetFileUpload();

                    $scope.certificate = {
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName(),
                        expirationDate: new Date(),
                        revocationPin: '',
                        userId: authExtend.getUserId()
                    }

                };

                $scope.load();
            }
        ]);
})();
